<template>
    <div id="classifybook">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">{{title}}</span>
            <span class="tr" @click="searchShow = !searchShow">筛选</span>
        </div>

        <ul class="booklist" v-infinite-scroll="doSearch" style="overflow:auto">
            <router-link :to="{name:'Book',params:{wid:item.wid}}" tag="li" v-for="item in booklist">
                <span class="finish"><img :src="require('./../assets/images/finish' + item.is_finish +'.png')" alt=""></span>
                <el-image :src="'http://static.yuread.cn/' + item.h_cover + '@!thumb'" fit="fit" lazy></el-image>
                <div>
                    <p class="title">{{item.title}}</p>
                    <p class="description">{{item.sort_description}}</p>
                    <p class="author">{{item.author}}</p>
                </div>

            </router-link>


        </ul>

        <div class="search-box" v-show="searchShow">
            <ul>
                <li>
                    <p>分类</p>
                    <dl>
                        <dd :class="{active:cid == $route.params.cid}" @click="cid = $route.params.cid">全部</dd>
                        <dd v-for="item in list" :class="{active:cid == item.id}" @click="cid = item.id">{{item.title}}</dd>
                    </dl>
                </li>
                <li>
                    <p>状态</p>
                    <dl>
                        <dd :class="{active:finish == 0}" @click="finish=0">全部</dd>
                        <dd :class="{active:finish == 1}" @click="finish=1">连载</dd>
                        <dd :class="{active:finish == 2}" @click="finish=2">完结</dd>
                    </dl>
                </li>
                <li>
                    <p>价格</p>
                    <dl>
                        <dd :class="{active:vip == 0}" @click="vip=0">全部</dd>
                        <dd :class="{active:vip == 1}" @click="vip=1">免费</dd>
                        <dd :class="{active:vip == 2}" @click="vip=2">付费</dd>
                    </dl>
                </li>
                <li>
                    <p>字数</p>
                    <dl>
                        <dd :class="{active:word == 0}" @click="word=0">全部</dd>
                        <dd :class="{active:word == 1}" @click="word=1"><p>30万字</p><p>以下</p></dd>
                        <dd :class="{active:word == 2}" @click="word=2"><p>30-50</p><p>万字</p></dd>
                        <dd :class="{active:word == 3}" @click="word=3"><p>50-100</p><p>万字</p></dd>
                        <dd :class="{active:word == 4}" @click="word=4"><p>100万字</p><p>以上</p></dd>

                    </dl>
                </li>
                <li>
                    <p>排序</p>
                    <dl>
                        <dd :class="{active:order == 1}" @click="order=1">按点击</dd>
                        <dd :class="{active:order == 2}" @click="order=2">按收藏</dd>
                        <dd :class="{active:order == 3}" @click="order=3">按字数</dd>
                        <dd :class="{active:order == 4}" @click="order=4">按订阅</dd>

                    </dl>
                </li>
            </ul>
            <div class="btn">
                <button class="reset" @click="cid = $route.params.cid;finish=0;vip=0;word=0;order=1;">重置</button>
                <button @click="searchbtn">查询</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Classifybook",
        data(){
            return  {
                title : '',
                list : [],
                booklist : [],
                searchShow : false,

                cid : this.$route.params.cid,
                finish : 0,
                vip : 0,
                word:0,
                order : 1,
                page : 1,
                limit : 20
            }
        },
        methods : {
            getClassifySon(){
                this.axios.post('/api/classify/getClassifySon',{
                    id : this.$route.params.cid
                }).then(r => {
                    this.title = r.data.data.title;
                    this.list = r.data.data.son;
                })
            },
            doSearch(){
                this.axios.post('/api/search/classifybook',{
                    cid : this.cid,
                    finish : this.finish,
                    vip : this.vip,
                    word:this.word,
                    order : this.order,
                    page : this.page,
                    limit : this.limit
                }).then(r=>{
                    let data = r.data.data.data;
                    data.forEach(v =>{
                        this.booklist.push(v);

                    })
                    this.page ++;
                })
            },searchbtn(){
                this.booklist = [];
                this.page=1;
                this.doSearch();
                this.searchShow =false;
            }
        },
        created() {
            this.getClassifySon()

        }
    }
</script>

<style lang="less">
    #classifybook{background: #f6f6f7;overflow: hidden;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .booklist{padding: 20px;background: #fff;height: calc(100% - 100px);
            li{overflow: auto;border-bottom: 1px solid #efefef;padding: 10px 0;position:relative;
                .el-image{width:120px;height: 160px !important;float: left;box-shadow: 0 1px 3px rgba(0,0,0,.3);padding: 0;
                    img{height: 100%;height:100%;}
                }
                div{float: left;width:580px; padding-left: 20px;
                    p{padding: 5px 0;}
                    .title{font-size: 28px;color: #272727;}
                    .description{color:#666;font-size: 24px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
                    .author{color:#b0b0b0;font-size: 24px;}
                }

                .finish{width:60px;height:60px;position: absolute;top:6px;left:-1px;z-index: 99;
                    img{width:100%;height:100%;box-shadow: none;}
                }
            }
        }
        .search-box{position: fixed;top: 96px;left:0;right:0;bottom: 0;background: #fff;padding: 40px 0  100px 40px;overflow: auto;z-index: 999;
            li{overflow: auto;padding-bottom: 20px;
                p{font-size: 26px;color:#272727;line-height: 50px;}
                dl{
                    dd{width:152px;height:80px;float: left;line-height: 80px;text-align: center;border-radius:8px;margin:0 20px 20px 0;font-size: 24px;background: #F0F0F0;border:1px solid #F0F0F0;
                        p{line-height: 40px;}
                    }
                    dd.active{color:@theme;border:1px solid @theme;background: #fff;}
                }
            }

            .btn{
                position: fixed;bottom:0;width:100%;height:100px;left: 0;z-index: 999;
                button{height: 100%;width:50%;background: @theme;border:0;color:#fff;font-size: 30px;}
                .reset{background: orange;}
            }
        }
    }
</style>
